import { transparentColors } from '@assets/styles/helpers/colors.styles'

export const getButtonStyles = (variant: 'text' | 'outlined' | 'contained') => {
  switch (variant) {
    case 'contained':
      return {
        boxShadow: 'none',
        backgroundColor: 'var(--primary)',
        color: 'var(--secondary)',
        textAlign: 'center',
        width: '100%',
        outline: 'none !important',
        border: 'none',
        '&.Mui-disabled': {
          backgroundColor: 'var(--primary)'
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'var(--primary)'
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: 'var(--primary)'
        }
      }
    case 'outlined':
      return {
        boxShadow: 'none',
        backgroundColor: transparentColors.transparent,
        color: 'var(--primary)',
        textAlign: 'center',
        width: '100%',
        outline: 'none !important',

        border: `2px solid ${'var(--primary)'}`,
        '&.Mui-disabled': {
          color: 'var(--primary)',
          border: `2px solid ${'var(--primary)'}`,
          backgroundColor: transparentColors.transparent
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: transparentColors.transparent,
          border: `2px solid ${'var(--primary)'}`
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: transparentColors.transparent,
          border: `2px solid ${'var(--primary)'}`
        }
      }
    case 'text':
      return {
        boxShadow: 'none',
        backgroundColor: transparentColors.transparent,
        textAlign: 'center',
        width: '100%',
        outline: 'none !important',
        border: 'none',
        color: 'var(--primary)',
        '&.Mui-disabled': {
          color: 'var(--primary)'
        },
        '&:hover': {
          boxShadow: 'none',
          color: 'var(--primary)'
        },
        '&:active': {
          boxShadow: 'none',
          color: 'var(--primary)'
        }
      }
    default:
      return {
        boxShadow: 'none',
        backgroundColor: 'var(--primary)',
        color: 'var(--secondary)',
        textAlign: 'center',
        width: '100%',
        outline: 'none !important',

        border: 'none',
        '&.Mui-disabled': {
          backgroundColor: 'var(--primary)'
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'var(--primary)'
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: 'var(--primary)'
        }
      }
  }
}
